/* Digital products now use the native premium product and catalog media layouts.
   The former DOM replacement hid product photography and could collapse the page. */
(function () {
  'use strict';
  function clearLegacyDigitalState() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.classList.remove('av-digital');
    main.removeAttribute('data-av-digital');
    main.querySelectorAll('.av-digital-visual, .av-digital-kicker').forEach(function (node) {
      node.remove();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearLegacyDigitalState);
  } else {
    clearLegacyDigitalState();
  }
  document.addEventListener('shopify:section:load', clearLegacyDigitalState);
})();